import { ProductTileSize } from './types'

const mapperSkeletonSize: Map<ProductTileSize, number> = new Map([
  [ProductTileSize.small, 112],
  [ProductTileSize.medium, 160],
  [ProductTileSize.large, 192],
])

export const getSkeletonSize = (size: ProductTileSize) => mapperSkeletonSize.get(size) || 160
